import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values
export var TextEncoder =
/*#__PURE__*/
function () {
  function TextEncoder() {
    _classCallCheck(this, TextEncoder);
  }

  _createClass(TextEncoder, [{
    key: "encode",
    value: function encode(value) {
      var u8a = new Uint8Array(value.length);

      for (var i = 0; i < value.length; i++) {
        u8a[i] = value.charCodeAt(i);
      }

      return u8a;
    }
  }]);

  return TextEncoder;
}();